import React, { Dispatch, FC, PropsWithChildren, SetStateAction } from 'react';
import { OperationSearchItem } from '@interfaces/search';
import { DetailsPageLayoutWrapper } from '@v2/pages/common/components/DetailsPageLayoutWrapper/DetailsPageLayoutWrapper';
import ProductionOrderJobsList, { ProductionOrderListJobId } from '@v2/pages/productionOrder/modules/productionOrder/components/ProductionOrderJobsList';
import { ProductionOrderContentProps } from '@v2/pages/productionOrder/modules/productionOrder/components/ProductionOrderContent';
import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import ColorWrapper from '@styles/colors';
import { StyleProp, ViewStyle } from 'react-native';
import { isPhone } from '@helpers';
import { PaginatedResponse } from '@interfaces/machines';
import { LevelSubScreen } from '@v2/pages/common/enums';
import { useManageProductionOrderContentWrapper } from './hooks/useManageProductionOrderContentWrapper';

export interface ProductionOrderContentWrapperProps
  extends Pick<ProductionOrderContentProps, 'productionOrder' | 'loading' | 'scale' | 'font'>,
    PropsWithChildren {
  setTotalCount?: Dispatch<SetStateAction<number>>;
  setIsError?: Dispatch<SetStateAction<boolean>>;
  onListItemPress?: (jobId: ProductionOrderListJobId) => void;
  setJobsApiCall?: (cb: () => Promise<PaginatedResponse<OperationSearchItem>>) => void;
  withProductionOrdersNavigation?: boolean;
  listStyle?: StyleProp<ViewStyle>;
  setNoData?: (state: boolean) => void;
  activeLevelSubScreenName?: LevelSubScreen;
}

const ProductionOrderContentWrapper: FC<ProductionOrderContentWrapperProps> = ({
  productionOrder,
  loading,
  onListItemPress,
  listStyle,
  setNoData,
  children,
  setIsError,
  setTotalCount,
  setJobsApiCall,
  activeLevelSubScreenName,
  withProductionOrdersNavigation = false,
  scale = initialScale,
  font = initialFont,
}) => {
  useManageProductionOrderContentWrapper({
    productionOrder,
    setJobsApiCall,
    setIsError,
    setNoData,
    setTotalCount,
  });

  const ListComponent = (
    <ProductionOrderJobsList
      {...{ productionOrder, loading: loading, scale, font, onListItemPress, withProductionOrdersNavigation, listStyle, activeLevelSubScreenName }}
    />
  );

  if (isPhone) {
    return children;
  }

  return (
    <DetailsPageLayoutWrapper scale={scale} ListComponent={ListComponent}>
      {children}
    </DetailsPageLayoutWrapper>
  );
};

export default ColorWrapper(ProductionOrderContentWrapper);
